import { render } from "./InviteUserListPage.vue?vue&type=template&id=07d05532"
import script from "./InviteUserListPage.vue?vue&type=script&lang=js"
export * from "./InviteUserListPage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__